import React from "react";
import { LoadingIndicator } from "./LoadingIndicator";

export const DetailsLoader: React.FC<{ loading: boolean; title: string }> = ({
  loading,
  children,
  title
}) => {
  if (loading) {
    return (
      <div className="saving-container">
        <LoadingIndicator title={title} />
      </div>
    );
  }

  return <>{children}</>;
};
